export default __webpack_public_path__ + "static/media/check.45c4dc3f.svg";